(function () {
  function prepare(video) {
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('loop', '');
    video.removeAttribute('controls');
  }

  function safePlay(video) {
    prepare(video);
    if (video.preload === 'none') video.preload = 'metadata';
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function safePause(video) {
    if (!video.paused) video.pause();
  }

  function initBenefitsVideos(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var medias = scope.querySelectorAll('[data-benefits-media]');
    if (!medias.length) return;

    var fresh = [];
    medias.forEach(function (media) {
      if (media.dataset.benefitsInit === '1') return;
      media.dataset.benefitsInit = '1';
      var video = media.querySelector('video');
      if (video) fresh.push({ media: media, video: video });
    });
    if (!fresh.length) return;

    fresh.forEach(function (item) {
      prepare(item.video);
    });

    if (!('IntersectionObserver' in window)) {
      fresh.forEach(function (item) {
        safePlay(item.video);
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target.querySelector('video');
          if (!video) return;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.25) {
            safePlay(video);
          } else {
            safePause(video);
          }
        });
      },
      { rootMargin: '120px 0px', threshold: [0, 0.25, 0.5] }
    );

    fresh.forEach(function (item) {
      observer.observe(item.media);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initBenefitsVideos(document);
    });
  } else {
    initBenefitsVideos(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initBenefitsVideos(event.target);
  });
})();
